@if (showNavBar) {
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateBack()">arrow_back</mat-icon>
    <span class="title">Shipment Document</span>
  </div>
}
<div  class="margin-top-md">{{ errorMessage }}</div>

<div >
  <div class="margin-left-md">{{ fileType }}</div>
  <div class="margin-right-md">
    <a mat-raised-button color="primary" [href]="previewImage" target="_blank" download>Download</a>
  </div>
</div>
@if (previewImage) {
  <img [src]="previewImage" class="imagePreview padding-md" />
}
